import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHolerite } from '@core/models';
import { AppState } from '@store/store';

interface IHoleriteState {
    data: IHolerite;
    loading: boolean;
    error: string | null;
}

const initialState: IHoleriteState = {
    data: {} as IHolerite,
    error: null,
    loading: false
};

export const holeriteSlice = createSlice({
    name: 'holerite',
    initialState,
    reducers: {
        holerite_fetching: (state) => {
            state.loading = true;
            state.data = {} as IHolerite;
            state.error = null;
        },
        holerite_success: (state, action: PayloadAction<IHolerite>) => {
            state.data = action.payload;
            state.loading = false;
            state.error = null;
        },
        holerite_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.data = {} as IHolerite;
        }
    }
});

export const { holerite_fetching, holerite_success, holerite_error } = holeriteSlice.actions;

export const selectorHolerite = (state: AppState) => state.holerite;

export default holeriteSlice.reducer;
